import { render } from "./ActorListing.vue?vue&type=template&id=39b6faf6"
import script from "./ActorListing.vue?vue&type=script&lang=js"
export * from "./ActorListing.vue?vue&type=script&lang=js"
script.render = render

export default script